
export class Organiser {
    id?:string;
    title:string = "";
    logoImage?:string;
    owner?: string;
}